import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

import { HistoryPeriod } from '../model/ride-history.model';

@Injectable()
export class RideHistoryActions {
    static FETCH_RIDE_HISTORY = '[RideHistory]: Fetch start';
    static FETCH_RIDE_HISTORY_SUCCESS = '[RideHistory]: Fetch success';
    static FETCH_RIDE_HISTORY_ERROR = '[RideHistory]: Fetch error';

    static SET_START_DATE = '[RideHistory]: Set start date';
    static SET_END_DATE = '[RideHistory]: Set end date';

    fetchRideHistory(payload: HistoryPeriod): RidangoReduxAction {
        return {
            type: RideHistoryActions.FETCH_RIDE_HISTORY,
            payload: payload,
        };
    }

    fetchRideHistorySuccess(payload: any): RidangoReduxAction {
        return {
            type: RideHistoryActions.FETCH_RIDE_HISTORY_SUCCESS,
            payload: payload,
        };
    }

    fetchRideHistoryFail(error: any): RidangoReduxAction {
        return {
            type: RideHistoryActions.FETCH_RIDE_HISTORY_ERROR,
            payload: error,
        };
    }

    setStartDate(payload: Date): RidangoReduxAction {
        return {
            type: RideHistoryActions.SET_START_DATE,
            payload: payload,
        };
    }

    setEndDate(payload: Date): RidangoReduxAction {
        return {
            type: RideHistoryActions.SET_END_DATE,
            payload: payload,
        };
    }
}
